var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.computedClass,attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.loading)?_c('spinner'):(_vm.successStateVisible)?_c('span',{staticClass:"flex items-center space-x-1"},[_c('heroicon',{staticClass:"w-5 h-5",attrs:{"icon":"check"}}),_c('span',[_vm._v("Saved")])],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }